import getServiceTeams from "@fartherfinance/frontend/api/Entity/requests/getServiceTeams";
import { AdvisorRequestConfig } from "@fartherfinance/frontend/api/Types";

import { cache5Min } from "../../core/cache";
import {
  EnumOption,
  isResourceTypeWithValue,
  ResourceTypeResponse,
} from "../../core/types";

export const fetchServiceTeams = async (
  requestConfig: AdvisorRequestConfig,
  values: ResourceTypeResponse[]
): Promise<EnumOption[]> => {
  if (
    !Array.isArray(values) ||
    !values.every((value) => isResourceTypeWithValue(value)) ||
    values.length === 0
  ) {
    return [];
  }

  const serviceTeams = await cache5Min("serviceTeam", () =>
    getServiceTeams({
      jwt: requestConfig.jwt,
      advisorId: requestConfig.advisorId,
    })
  );

  if (!serviceTeams) {
    return [];
  }

  // Create a map of service teams by ID for quick lookup
  const serviceTeamMap = new Map(
    serviceTeams.map((team) => [String(team.serviceTeamId), team])
  );

  // Use a functional approach with reduce to maintain order
  const serviceTeamOptions = values
    .filter(isResourceTypeWithValue)
    .map((resource) => {
      const team = serviceTeamMap.get(String(resource.value));

      // Skip resources that don't have a matching team
      if (!team) {
        return null;
      }

      return {
        type: resource.type,
        kind: resource.kind,
        label: team.name,
        value: String(team.serviceTeamId),
      };
    })
    .filter((option): option is NonNullable<typeof option> => option !== null);

  return serviceTeamOptions as EnumOption[];
};
